import { SearchResultEnriched } from 'lib-search-types';

import { searchApi } from 'apis/search';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { SearchResultsEmpty } from './components/empty/searchResultsEmpty';
import { SearchResultsLoading } from './components/loading/searchResultsLoading';
import { ConversationsResults } from './components/types/conversations/conversationsResults';
import styles from './searchResults.module.scss';

export const SearchResults = (): JSX.Element => {
  const { params } = useAppSelector((state) => state.search);

  const { results, meta, isFetching } =
    searchApi.endpoints.readAdvancedSearchResults.useQueryState(
      { ...params, enrichmentSpec: 'ALL' },
      {
        selectFromResult: ({ data, ...rest }) => ({
          ...rest,
          results: data?.data.results,
          meta: data?.meta,
        }),
      },
    );

  if (!results?.length) return <SearchResultsEmpty />;

  return (
    <div className={styles.root}>
      {isFetching && <SearchResultsLoading isOverlay />}

      <ConversationsResults
        results={results as readonly SearchResultEnriched<'conversations'>[]}
        meta={meta}
      />
    </div>
  );
};
